import React, { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import {
  buildWorkspaceChips,
  buildWorkspaceSidebarItems,
  normalizeWorkspaceRoute,
} from './workspaceRouteModel';

function WorkspaceRouteController({
  config,
  sectionId,
  viewId,
  routeState = {},
  children,
}) {
  const resolvedRoute = useMemo(() => (
    config.resolveRoute
      ? config.resolveRoute({ sectionId, viewId, routeState })
      : normalizeWorkspaceRoute({
        sections: config.sections,
        defaultSectionId: config.defaultSectionId,
        defaultViewId: config.defaultViewId,
        sectionId,
        viewId,
      })
  ), [config, routeState, sectionId, viewId]);

  const canonicalPath = config.buildPath({
    sectionId: resolvedRoute.sectionId,
    viewId: resolvedRoute.viewId,
    ...routeState,
  });

  if (config.shouldRedirect?.({ sectionId, viewId, routeState, resolvedRoute }) ?? (
    sectionId !== resolvedRoute.sectionId || viewId !== resolvedRoute.viewId
  )) {
    return <Navigate to={canonicalPath} replace />;
  }

  const sidebarItems = buildWorkspaceSidebarItems({
    sections: config.sections,
    buildPath: config.buildPath,
    routeState,
  });
  const extraChips = config.getExtraChips?.({ routeState, resolvedRoute }) || [];
  const chips = config.getChips
    ? config.getChips({ routeState, resolvedRoute })
    : buildWorkspaceChips({
      section: resolvedRoute.section,
      view: resolvedRoute.view,
      routeState,
      extraChips,
    });

  return children({
    ...resolvedRoute,
    sidebarItems,
    chips,
  });
}

export default WorkspaceRouteController;
